module.exports = __webpack_public_path__ + "static/img/angle-right.a842f11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/angle-right.svg
// module id = nzVJ
// module chunks = 1